// components/MicroFrontendWrapper.jsx
import { createBrowserHistory } from "history";
import { isEmpty } from "lodash";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MicroFrontend from "../../MicroFrontend";
import SCAILayout from "../../components/SCAILayout";

const defaultHistory = createBrowserHistory();

const SCAIFrontendWrapper = ({ host, name, id, requireAuth = false }) => {
  const navigate = useNavigate();
  const user = requireAuth
    ? JSON.parse(localStorage.getItem("user") || "null")
    : null;

  useEffect(() => {
    if (requireAuth && isEmpty(user)) {
      navigate("/");
    }
  }, [requireAuth, user, navigate]);
  return (
    <SCAILayout>
      <div id={id}>
        <MicroFrontend history={defaultHistory} host={host} name={name} />
      </div>
    </SCAILayout>
  );
};

export default SCAIFrontendWrapper;
